import { types, actions } from './requests'
export const GETTIMECALENDAR_TYPES = {
    ...types('GETTIMECALENDAR'),
}
export const GETTIMECALENDAR_ACTIONS = {
    ...actions('GETTIMECALENDAR'),
}